export default __webpack_public_path__ + "static/media/planet-uranus.e91b297f.svg";